import {ShowAlertPayload} from "interfaces";
import {initialState} from "./initial-state";
import {PayloadAction, createSlice} from "@reduxjs/toolkit";

export const alert = createSlice({
  name: "alert",
  initialState,
  reducers: {
    showAlert: function (state, action: PayloadAction<ShowAlertPayload>) {
      const {durationMS, message, title, type} = action["payload"];

      state["type"] = type;
      state["title"] = title;
      state["message"] = message;
      state["durationMS"] = durationMS ?? 5000;
      state["shown"] = true;
    },
    hideAlert: function (state) {
      state["type"] = initialState["type"];
      state["shown"] = initialState["shown"];
      state["title"] = initialState["title"];
      state["message"] = initialState["message"];
      state["durationMS"] = initialState["durationMS"];
    },
  },
});

export default alert["reducer"];
export const {showAlert, hideAlert} = alert["actions"];
